import React from 'react';
import PropTypes from 'prop-types';
import Heading from './Heading';
import DaysOfWeek from './DaysOfWeek';
import MonthSelector from './MonthSelector';
import Day from './Day';
import { getDaysOfMonth } from '../utils/moment-helper';
import moment from 'moment-jalali';

// Load Persian localisation
moment.loadPersian();

export default class Calendar extends React.Component {
  static propTypes = {
    min: PropTypes.object,
    max: PropTypes.object,
    selectedDay: PropTypes.object,
    selectedDays: PropTypes.array,
    disableDays: PropTypes.array,
    defaultMonth: PropTypes.object,
    onSelect: PropTypes.func
  };

  static childContextTypes = {
    nextMonth: PropTypes.func.isRequired,
    prevMonth: PropTypes.func.isRequired,
    setCalendarMode: PropTypes.func.isRequired,
    setMonth: PropTypes.func.isRequired
  };

  state = {
    month: this.props.defaultMonth || this.props.selectedDay || moment(this.props.min),
    selectedDay: this.props.selectedDay || null,
    mode: 'days'
  };

  getChildContext() {
    return {
      nextMonth: this.nextMonth.bind(this),
      prevMonth: this.prevMonth.bind(this),
      setCalendarMode: this.setMode.bind(this),
      setMonth: this.setMonth.bind(this)
    };
  }

  componentWillReceiveProps({ selectedDay, defaultMonth, min }) {
    if (this.props.selectedDay !== selectedDay) {
      this.selectDay(selectedDay);
    } else if (
      defaultMonth &&
      this.props.defaultMonth !== defaultMonth &&
      this.state.month === this.props.defaultMonth
    ) {
      this.setMonth(defaultMonth);
    } else if (min && this.props.min !== min && this.state.month.isSame(this.props.min)) {
      this.setMonth(min.clone());
    }
  }

  setMode(mode) {
    this.setState({ mode });
  }

  setMonth(month) {
    this.setState({ month });
  }

  nextMonth() {
    this.setState({
      month: this.state.month.clone().add(1, 'jMonth')
    });
  }

  prevMonth() {
    this.setState({
      month: this.state.month.clone().subtract(1, 'jMonth')
    });
  }

  selectDay(selectedDay) {
    const { month } = this.state;
    if (selectedDay.format('jYYYYjMM') !== month.format('jYYYYjMM')) {
      this.setState({ month: selectedDay });
    }

    // this.setState({ selectedDay });
  }

  handleClickOnDay = selectedDay => {
    const { onSelect } = this.props;
    this.selectDay(selectedDay);
    if (onSelect) {
      onSelect(selectedDay);
    }
  };

  days = null;
  lastRenderedMonth = null;

  renderMonthSelector() {
    const { month } = this.state;
    return <MonthSelector selectedMonth={month} />;
  }

  renderDays() {
    const { month } = this.state;
    const { min, max, selectedDay, selectedDays, disableDays } = this.props;
    let days;

    if (this.lastRenderedMonth === month) {
      days = this.days;
    } else {
      days = getDaysOfMonth(month);
      this.days = days;
      this.lastRenderedMonth = month;
    }

    return (
      <div>
        <Heading month={month} />
        <DaysOfWeek />
        <div className="calendar-container">
          {days.map(day => {
            const isCurrentMonth = day.format('jMM') === month.format('jMM');
            let disabled = false;
            let selected = false;

            if ((min ? day.isBefore(min) : false) || (max ? day.isAfter(max) : false)) {
              disabled = true;
            }

            if (disableDays && disableDays.length > 0) {
              disableDays.forEach(dDay => {
                if (dDay.isSame(day, 'day')) {
                  disabled = true;
                }
              });
            }

            if (selectedDay && selectedDay.isSame(day, 'day')) {
              selected = true;
            }

            if (selectedDays && selectedDays.length > 0) {
              selectedDays.forEach(sDay => {
                if (sDay.isSame(day, 'day')) {
                  selected = true;
                }
              });
            }

            return (
              <Day
                key={day.format('YYYYMMDD')}
                onClick={this.handleClickOnDay}
                day={day}
                disabled={disabled}
                selected={selected}
                isCurrentMonth={isCurrentMonth}
              />
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const { className, min, max, ...rest } = this.props;
    const { mode } = this.state;

    return (
      <div className={'calendar'} {...rest}>
        {mode === 'monthSelector' ? this.renderMonthSelector() : this.renderDays()}
      </div>
    );
  }
}
